export default __webpack_public_path__ + "static/media/d53.7ee29c98.png";